export { default, type LinkProps } from './Link';
export { default as getAnchorRel } from './getAnchorRel';
